"use client";

import { Link } from "@repo/ui/navigation";

import type { WalletFooterDTO } from "../../types/cms/profile-page";

interface WalletFooterProps {
  cms: WalletFooterDTO;
}

export function WalletFooter({ cms }: Readonly<WalletFooterProps>) {
  return (
    <footer className="mt-8 pt-6" data-testid="wallet-footer">
      <div className="flex items-center justify-center md:justify-start gap-3 text-xs text-gray-500">
        <Link
          href={cms.termsOfUseHref}
          className="text-brand-gray hover:text-brand-cyan text-xs transition"
          data-testid="footer-terms-of-use"
        >
          {cms.termsOfUseLabel}
        </Link>
        <span className="text-gray-300">|</span>
        <Link
          href={cms.termsAndConditionsHref}
          className="text-brand-gray hover:text-brand-cyan text-xs transition"
          data-testid="footer-terms-and-conditions"
        >
          {cms.termsAndConditionsLabel}
        </Link>
      </div>
    </footer>
  );
}
